import { deleteApi, getApi, postApi, patchApi } from "./apiServiceFile";

export const deleteCoach = async (coachId) => {
    return await deleteApi(`/mp/coach/${coachId}`);
}

export const createCoach = async (data) => {
    return await postApi(`/mp/coach/create`, data, {
        "Content-Type": "multipart/form-data",
    })
}

export const UpdateCoach = async (data) => {
    return await patchApi(`/mp/coach/update`, data)
}

export const getAllCoaches = async () => {
    return await getApi("/mp/coach/all")
}